import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "up-2AY6l",
  "use": "up-2AY6l-usage",
  "viewBox": "0 0 9 4",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9 4\" id=\"up-2AY6l\"><path fill-rule=\"evenodd\" d=\"M4.5 0L9 4H0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol